import {RunRefundPreview, RunRefundResult} from '@/classes/dto/warehouse-manager/response/Shipping.types';
import {LeanDocument, Types} from 'mongoose';
import {API} from './api.class';
import {CreateWarehouseOrderRequestDto} from '@/classes/dto/warehouse-manager/request/CreateWarehouseOrder.request.dto';
import {WarehouseOrder} from '@/interfaces/warehouseOrder.interface';
import {
    GetArticlesWithPendingOrdersRequestDto,
} from '@/classes/dto/warehouse-manager/request/GetArticlesWithPendingOrders.request.dto';
import {GetOrderNumbersRequestDto} from '@/classes/dto/warehouse-manager/request/GetOrderNumbers.request.dto';
import {
    GetArticlesWithPendingOrdersResponseDto,
} from '@/classes/dto/warehouse-manager/response/GetArticlesWithPendingOrders.response.dto';
import {GetOrderNumbersResponseDto} from '@/classes/dto/warehouse-manager/response/GetOrderNumbers.response.dto';
import {GetStockRequestDto} from '@/classes/dto/warehouse-manager/request/GetStock.request.dto';
import {FindWarehouseOrderRequestDto} from '@/classes/dto/warehouse-manager/request/FindWarehouseOrder.request.dto';
import {FindByIdOptions} from '@/interfaces/findByIdOptions';
import {UpdateWarehouseOrderRequestDto} from '@/classes/dto/warehouse-manager/request/UpdateWarehouseOrder.request.dto';
import {
    MassFulfillWarehouseOrderRequestDto,
} from '@/classes/dto/warehouse-manager/request/MassFulfillWarehouseOrder.request.dto';
import {BulkUpdateResponseDto} from '@/classes/dto/_common/response/bulkUpdate.response.dto';
import {
    BulkUpdateWarehouseOrderRequestDto,
} from '@/classes/dto/warehouse-manager/request/BulkUpdateWarehouseOrder.request.dto';
import {FindByIdOptionsRequestDto} from '@/classes/dto/_common/request/FindByIdOptions.request.dto';
import {
    CreateProductOrderRequestDto,
} from '@/classes/dto/warehouse-manager/request/product-order/CreateProductOrder.request.dto';
import {
    FindProductOrderRequestDto,
} from '@/classes/dto/warehouse-manager/request/product-order/FindProductOrder.request.dto';
import {ProductOrderDocument} from '@/documentTypes/warehouse-manager/ProductOrder.document';
import {
    UpdateProductOrderRequestDto,
} from '@/classes/dto/warehouse-manager/request/product-order/UpdateProductOrder.request.dto';
import {ProductShipmentDocument} from '@/documentTypes/warehouse-manager/ProductShipment.document';
import {
    CreateProductShipmentsFromOrderRequestDto,
} from '@/classes/dto/warehouse-manager/request/product-shipment/CreateProductShipmentsFromOrder.request.dto';
import {PreviewRetoureMailsRequestDto} from '@/classes/dto/warehouse-manager/request/product-shipment/PreviewRetoureMails.request.dto';
import {SendReviewedRetoureMailsRequestDto} from '@/classes/dto/warehouse-manager/request/product-shipment/SendReviewedRetoureMails.request.dto';
import {MailDraftsPreviewResponseDto} from '@/classes/dto/_common/mail-review/MailDraft.dto';
import {MailReportResponseDto} from '@/classes/dto/_common/response/mailReport.response.dto';
import {
    FindProductShipmentRequestDto,
} from '@/classes/dto/warehouse-manager/request/product-shipment/FindProductShipment.request.dto';
import {
    BulkCreateProductShipmentRequestDto,
} from '@/classes/dto/warehouse-manager/request/product-shipment/BulkCreateProductShipment.request.dto';
import {
    UpdateProductShipmentRequestDto,
} from '@/classes/dto/warehouse-manager/request/product-shipment/UpdateProductShipment.request.dto';
import {
    GetProductOrderInventoryResponseDto,
} from '@/classes/dto/warehouse-manager/response/product-order/GetProductOrderInventory.response.dto';
import {
    GetProductOrderInventoryRequestDto,
} from '@/classes/dto/warehouse-manager/request/product-order/GetProductOrderInventory.request.dto';
import {
    CreateProductShipmentBundleRequestDto,
} from '@/classes/dto/warehouse-manager/request/product-shipment-bundle/CreateProductShipmentBundle.request.dto';
import {ProductShipmentBundleDocument} from '@/documentTypes/warehouse-manager/ProductShipmentBundle.document';
import {PaginationResponseType} from '@/types/common/paginationResponseType';
import {CrudEntityTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudEntityTypes';
import {
    FindProductShipmentBundleRequestDto,
} from '@/classes/dto/warehouse-manager/request/product-shipment-bundle/FindProductShipmentBundle.request.dto';
import {
    GetProductOrderRequiredStockRequestDto,
} from '@/classes/dto/warehouse-manager/request/product-order/GetProductOrderRequiredStock.request.dto';
import {
    GetProductOrderRequiredStockResponseDto,
} from '@/classes/dto/warehouse-manager/response/product-order/GetProductOrderRequiredStock.response.dto';

/**
 * This class is used for communicating with the warehouse manager microservice.
 * @author Joshua Seipel
 */
import {
    ReturnsPage,
    ShipmentListState,
    ShipmentPreview,
    ShipmentProblemType,
    ShipmentRun,
    ProductDemand,
    ShippingOverview,
} from '@/classes/dto/warehouse-manager/response/Shipping.types';

export class WarehouseManagerAPI extends API {
    static service = 'warehouse-manager';

    /**
     * @deprecated
     */
    static async createOrder(order: CreateWarehouseOrderRequestDto): Promise<WarehouseOrder> {
        return this.post(`warehouse-order/`, order);
    }

    /**
     * @deprecated
     */
    static async getStock(articleId: Types.ObjectId, data: GetStockRequestDto): Promise<number> {
        return this.get(`warehouse-order/stock/${articleId}`, data);
    }

    /**
     * @deprecated
     */
    static async findById(id: Types.ObjectId, options?: FindByIdOptions): Promise<WarehouseOrder> {
        return this.get(`warehouse-order/${id}`, options);
    }

    /**
     * @deprecated
     */
    static async find(data: FindWarehouseOrderRequestDto): Promise<{
        warehouseOrders: WarehouseOrder[];
        maxPage: number
    }> {
        return this.get(`warehouse-order`, data);
    }

    /**
     * @deprecated
     */
    static async massFulfill(update: MassFulfillWarehouseOrderRequestDto): Promise<void> {
        return this.put('warehouse-order/mass-fulfill', update);
    }

    /**
     * @deprecated
     */
    static async update(id: Types.ObjectId, update: UpdateWarehouseOrderRequestDto): Promise<void> {
        return this.put(`warehouse-order/${id}`, update);
    }

    /**
     * @deprecated
     */
    static async bulkUpdate(bulkUpdateData: BulkUpdateWarehouseOrderRequestDto): Promise<BulkUpdateResponseDto> {
        return this.put(`warehouse-order/bulk`, bulkUpdateData);
    }

    /**
     * @deprecated
     */
    static async getArticlesWithPendingOrders(data: GetArticlesWithPendingOrdersRequestDto): Promise<GetArticlesWithPendingOrdersResponseDto> {
        return this.get(`warehouse-order/aggregation/articles-with-pending-orders`, data);
    }

    /**
     * @deprecated
     */
    static async getOrderNumbers(data: GetOrderNumbersRequestDto): Promise<GetOrderNumbersResponseDto> {
        return this.get('warehouse-order/aggregation/order-numbers', data);
    }

    /**
     * @deprecated
     */
    static async remove(id: Types.ObjectId): Promise<void> {
        return this.delete(`warehouse-order/${id}`);
    }

    static productOrder = {
        async create(data: CreateProductOrderRequestDto): Promise<Types.ObjectId> {
            return WarehouseManagerAPI.post('product-order', data);
        },
        /**
         * „Sendung anlegen“: wie create, zusätzlich je Stück eine eigene Bestellung (separatePieceProducts) und Wahl je
         * Produkt teamweit merken (rememberSeparatePieces). Alles oder nichts; Antwort: alle IDs, die erste = Hauptbestellung.
         */
        async createMany(data: CreateProductOrderRequestDto & {
            separatePieceProducts?: Array<Types.ObjectId | string>,
            rememberSeparatePieces?: boolean,
        }): Promise<{ ids: Types.ObjectId[] }> {
            return WarehouseManagerAPI.post('product-order/many', data);
        },
        /** Gemerkte Wahl „je Stück eine eigene Sendung“ je Produkt (fehlt = „alle zusammen“) */
        async getDefaults(products: Array<Types.ObjectId | string>): Promise<{ items: Array<{ product: Types.ObjectId, separatePieces: boolean }> }> {
            return WarehouseManagerAPI.get('product-order/defaults', {products});
        },
        async getRequiredStock(data: GetProductOrderRequiredStockRequestDto): Promise<GetProductOrderRequiredStockResponseDto> {
            return WarehouseManagerAPI.get('product-order/required-stock', data);
        },
        async getInventory(data: GetProductOrderInventoryRequestDto): Promise<GetProductOrderInventoryResponseDto> {
            return WarehouseManagerAPI.get('product-order/inventory', data);
        },
        async find(data: FindProductOrderRequestDto): Promise<{
            productOrders: LeanDocument<ProductOrderDocument>[];
            maxPage: number;
        }> {
            return WarehouseManagerAPI.get('product-order', data);
        },
        async findById(id: Types.ObjectId | string, options?: FindByIdOptionsRequestDto): Promise<LeanDocument<ProductOrderDocument>> {
            return WarehouseManagerAPI.get(`product-order/${id}`, options);
        },
        async update(id: Types.ObjectId | string, data: UpdateProductOrderRequestDto): Promise<Types.ObjectId> {
            return WarehouseManagerAPI.put(`product-order/${id}`, data);
        },
        async delete(id: Types.ObjectId | string): Promise<Types.ObjectId> {
            return WarehouseManagerAPI.delete(`product-order/${id}`);
        },
    }

    static productShipment = {
        async create(data: CreateProductShipmentsFromOrderRequestDto): Promise<Types.ObjectId[]> {
            return WarehouseManagerAPI.post('product-shipment', data);
        },
        /** Review flow of the retoure mail (label as attachment): rendered drafts of the retoure shipments */
        async previewRetoureMails(data: PreviewRetoureMailsRequestDto): Promise<MailDraftsPreviewResponseDto> {
            return WarehouseManagerAPI.post('product-shipment/retoure-mail/preview', data);
        },
        /** Review flow of the retoure mail: sends the (edited) drafts with the label through the messenger */
        async sendReviewedRetoureMails(data: SendReviewedRetoureMailsRequestDto): Promise<MailReportResponseDto> {
            return WarehouseManagerAPI.post('product-shipment/retoure-mail/send', data);
        },
        async bulkCreate(data: BulkCreateProductShipmentRequestDto): Promise<Types.ObjectId[]> {
            return WarehouseManagerAPI.post('product-shipment/bulk', data);
        },
        async find(data: FindProductShipmentRequestDto): Promise<{
            productShipments: LeanDocument<ProductShipmentDocument>[];
            maxPage: number;
        }> {
            return WarehouseManagerAPI.get('product-shipment', data);
        },
        async findById(id: Types.ObjectId | string, options?: FindByIdOptionsRequestDto): Promise<LeanDocument<ProductShipmentDocument>> {
            return WarehouseManagerAPI.get(`product-shipment/${id}`, options);
        },
        async update(id: Types.ObjectId | string, data: UpdateProductShipmentRequestDto): Promise<Types.ObjectId> {
            return WarehouseManagerAPI.put(`product-shipment/${id}`, data);
        },
        async delete(id: Types.ObjectId | string): Promise<Types.ObjectId> {
            return WarehouseManagerAPI.delete(`product-shipment/${id}`);
        },
        /** „Erneut versuchen“: Label einer fehlgeschlagenen Sendung neu erzeugen (gleiche Sendung, aktuelle Adresse der Bestellung) */
        /** Kostenvorschau vor „Labels erstellen“ (nichts wird gespeichert oder gekauft) */
        async preview(data: {orders?: Array<{productOrder: Types.ObjectId | string, items?: Array<Types.ObjectId | string>}>, filter?: Record<string, any>, products?: Array<Types.ObjectId | string>, useRetoure?: boolean, splitItemIds?: Array<Types.ObjectId | string>, piecesSeparately?: boolean}): Promise<ShipmentPreview> {
            return WarehouseManagerAPI.post('product-shipment/preview', data);
        },
        async overview(): Promise<ShippingOverview> {
            return WarehouseManagerAPI.get('product-shipment/overview');
        },
        /** Bedarf je Produkt: offene Stück nach Fälligkeit (heute / diese Woche / nächste Woche / später) + offene Rücksendungen */
        async demand(): Promise<ProductDemand> {
            return WarehouseManagerAPI.get('product-shipment/demand');
        },
        async problems(type: ShipmentProblemType): Promise<{productShipments: LeanDocument<ProductShipmentDocument>[], type: ShipmentProblemType}> {
            return WarehouseManagerAPI.get('product-shipment/problems', {type});
        },
        async byState(data: {state: ShipmentListState, page?: number, limit?: number, search?: string}): Promise<{productShipments: LeanDocument<ProductShipmentDocument>[], total: number, maxPage: number}> {
            return WarehouseManagerAPI.get('product-shipment/by-state', data);
        },
        /** DHL-Label stornieren – die Bestellung ist danach wieder „zu versenden“ */
        async cancel(id: Types.ObjectId | string): Promise<{cancelled: boolean, shipmentRef?: string}> {
            return WarehouseManagerAPI.post(`product-shipment/${id}/cancel`, {});
        },
        /** Druckauftrag: welche Briefmarken sich erstatten lassen */
        async runRefundPreview(runId: Types.ObjectId | string): Promise<RunRefundPreview> {
            return WarehouseManagerAPI.get(`product-shipment/run-refund/${runId}`);
        },
        /** Druckauftrag: alle erstattbaren Briefmarken auf einmal erstatten */
        async runRefund(runId: Types.ObjectId | string): Promise<RunRefundResult> {
            return WarehouseManagerAPI.post(`product-shipment/run-refund/${runId}`, {});
        },
        /** Probleme: als erledigt markieren (Grund Pflicht; releaseOrder = Bestellung wieder „zu versenden“) – nichts wird gelöscht */
        async resolveProblem(id: Types.ObjectId | string, data: {reason: string, releaseOrder?: boolean}): Promise<{
            problemResolvedAt: string, problemResolvedByName?: string, problemResolvedReason: string, releasedItems: number,
        }> {
            return WarehouseManagerAPI.post(`product-shipment/${id}/resolve-problem`, data);
        },
        /** Probleme: Vermerk „erledigt“ zurücknehmen */
        async reopenProblem(id: Types.ObjectId | string): Promise<{reopened: boolean}> {
            return WarehouseManagerAPI.post(`product-shipment/${id}/reopen-problem`, {});
        },
        async retry(id: Types.ObjectId | string, data: {deutschePostPageFormatId?: number, dhlPrintFormat?: string}): Promise<{
            _id: Types.ObjectId, errorMessage?: string, shipmentRef?: string, file?: Types.ObjectId, labelUrl?: string,
        }> {
            return WarehouseManagerAPI.post(`product-shipment/${id}/retry`, data);
        },
    }

    static shipmentRun = {
        async find(data: {page?: number, limit?: number}): Promise<{productShipmentRuns: ShipmentRun[], maxPage: number, total: number}> {
            return WarehouseManagerAPI.get('product-shipment-run', data);
        },
        async findById(id: Types.ObjectId | string): Promise<ShipmentRun> {
            return WarehouseManagerAPI.get(`product-shipment-run/${id}`);
        },
        /** Druckauftrag, zu dem eine Sendung gehört (der neueste) */
        async findByShipment(shipmentId: Types.ObjectId | string): Promise<ShipmentRun | null> {
            return WarehouseManagerAPI.get(`product-shipment-run/by-shipment/${shipmentId}`);
        },
    }

    static returns = {
        async find(data: {scope: 'current' | 'old', oldCaseDays?: number, page?: number, limit?: number}): Promise<ReturnsPage> {
            return WarehouseManagerAPI.get('product-order/returns', data);
        },
        async countOld(olderThanDays: number): Promise<{olderThanDays: number, total: number, withTermination: number, withLabel: number}> {
            return WarehouseManagerAPI.get('product-order/returns/old-count', {olderThanDays});
        },
        async deleteOld(data: {olderThanDays: number, ids?: Array<Types.ObjectId | string>}): Promise<{deleted: Types.ObjectId[], failed: Array<{id: Types.ObjectId, message: string}>}> {
            return WarehouseManagerAPI.post('product-order/returns/delete-old', data);
        },
    }

    static productShipmentBundle = {
        /** Versandpaket bearbeiten (gilt für künftige Labels) */
        async update(id: Types.ObjectId | string, data: CreateProductShipmentBundleRequestDto): Promise<Types.ObjectId> {
            return WarehouseManagerAPI.put(`product-shipment-bundle/${id}`, data);
        },
        async create(data: CreateProductShipmentBundleRequestDto): Promise<Types.ObjectId> {
            return WarehouseManagerAPI.post('product-shipment-bundle', data);
        },
        async findById(id: Types.ObjectId | string, options?: FindByIdOptionsRequestDto): Promise<LeanDocument<ProductShipmentBundleDocument>> {
            return WarehouseManagerAPI.get(`product-shipment-bundle/${id}`, options);
        },
        async find(data: FindProductShipmentBundleRequestDto): Promise<PaginationResponseType<CrudEntityTypes.PRODUCT_SHIPMENT_BUNDLE, ProductShipmentBundleDocument>> {
            return WarehouseManagerAPI.get('product-shipment-bundle', data);
        },
        async delete(id: Types.ObjectId | string): Promise<Types.ObjectId> {
            return WarehouseManagerAPI.delete(`product-shipment-bundle/${id}`);
        },
    }
}
